import { io, Socket } from "socket.io-client";
import { BattleBettingVolumeSnapshot } from "../api/bettingVolume";

type BettingPoolServerEvents = {
  "battle:subscribed": (payload: { battleId: string }) => void;
  "battle:unsubscribed": (payload: { battleId: string }) => void;
  "battle:error": (payload: { message: string }) => void;
  "battle:volume.updated": (payload: BattleBettingVolumeSnapshot) => void;
};

type BettingPoolClientEvents = {
  "battle:subscribe": (payload: { battleId: string }) => void;
  "battle:unsubscribe": (payload: { battleId: string }) => void;
};

export type BettingPoolSocket = Socket<
  BettingPoolServerEvents,
  BettingPoolClientEvents
>;

export const createBettingPoolSocket = (token: string): BettingPoolSocket => {
  const base = (process.env.REACT_APP_BACKEND_URL || window.location.origin).replace(/\/$/, "");

  return io(`${base}/betting`, {
    autoConnect: false,
    reconnection: true,
    withCredentials: true,
    auth: {
      token,
    },
  });
};
